import { render, staticRenderFns } from "./RecordCp.vue?vue&type=template&id=6587ad0e&scoped=true"
import script from "./RecordCp.vue?vue&type=script&lang=js"
export * from "./RecordCp.vue?vue&type=script&lang=js"
import style0 from "./RecordCp.vue?vue&type=style&index=0&id=6587ad0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6587ad0e",
  null
  
)

export default component.exports